import React from 'react';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/working-advisor-hero.webp';
import highResMobileImageWebp from './images/working-advisor-hero-mobile.webp';
import highResTabletImageWebp from './images/working-advisor-hero-tablet.webp';
// low res images
import { lowResImageDesktop, lowResImageTablet, lowResImageMobile } from './lowResImage';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='working-with-an-advisor-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Financial Advisors'
      headingText={
        <>Go from &#34;Can I&#63;&#34; to &#34;I can&#34; with <WidowBlock>our advisors.</WidowBlock></>
      }
      descriptionText={
        <>Having the right financial expert in your corner gives you the confidence to live the life you&#39;ve always wanted while being ready for whatever comes <WidowBlock>your way.</WidowBlock></>
      }
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Let\'s work together',
        ariaLabel: 'Find a financial advisor here.',
        children: '',
      }}
      backgroundImageAriaLabel='a woman in a suit shaking hands with a man in a suit in a meeting'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageTablet={highResTabletImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageTabletLowRes={lowResImageTablet}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
    />
  );};
